import React from "react";

const Chapter3 = () => {
  return (
    <>
      <h2>Why should I care about nutrients in the South Platte River?</h2>
      <p>
        When too much nitrogen and phosphorus enter the environment, algae grow
        faster than ecosystems can handle it. When it begins to die back, large
        growths of algae can severely reduce or eliminate oxygen in the water,
        leading to illnesses and death of large numbers of fish. Some algal
        blooms produce toxins or enhance the growth of bacteria that may be
        harmful to humans and their pets who recreate in the water, consume
        tainted fish or shellfish, or drink contaminated water.
      </p>
    </>
  );
};

export default Chapter3;
